module.exports = {
    methods: {
        redirectIfNeed(result) {
            if (result.data.data.redirect) {
                window.location = result.data.data.redirect;
            }
        }
    }
};
